import { __rest } from '../../_virtual/_tslib.js';
import { ThemePresentation } from '@lsg/shared';
import { createElement } from 'react';

/** @deprecated */
var Looks;
(function (Looks) {
  Looks["DARK"] = "dark";
  Looks["ELEVATED"] = "elevated";
  Looks["LIGHT"] = "light";
  Looks["MEDIUM"] = "medium";
  Looks["DEFAULT"] = "light";
})(Looks || (Looks = {}));
var Theme = function Theme(_a) {
  var _a$look = _a.look,
    look = _a$look === void 0 ? "dark" : _a$look,
    props = __rest(_a, ["look"]);
  return /*#__PURE__*/createElement(ThemePresentation, Object.assign({
    look: look
  }, props));
};
Theme.Looks = Looks;
Theme.displayName = "Theme";

export { Looks, Theme };
